var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 12.9999C22.75 13.414 22.4141 13.7499 22 13.7499H19C18.6772 13.7499 18.3906 13.5434 18.2886 13.2372L18.1031 12.6806L16.7276 18.1821C16.647 18.5053 16.3619 18.7368 16.0289 18.7495C16.0191 18.75 16.0094 18.75 16.0001 18.75C15.6783 18.75 15.3907 18.5444 15.2887 18.2373L12.0001 8.3716L8.7115 18.2373C8.6065 18.5537 8.317 18.7705 7.9713 18.7495C7.6383 18.7368 7.3531 18.5054 7.2726 18.1821L5.8971 12.6806L5.7116 13.2372C5.6095 13.5434 5.3229 13.7499 5.0002 13.7499H2C1.5859 13.7499 1.25 13.414 1.25 12.9999C1.25 12.5858 1.5859 12.2499 2 12.2499H4.4595L5.2886 9.7626C5.3936 9.4467 5.6856 9.2392 6.0288 9.2504C6.3618 9.2631 6.647 9.4945 6.7275 9.8178L8.103 15.3193L11.2885 5.7627C11.3906 5.4565 11.6772 5.25 11.9999 5.25C12.3226 5.25 12.6093 5.4565 12.7113 5.7627L15.8968 15.3193L17.2723 9.8178C17.3529 9.4946 17.638 9.2631 17.971 9.2504C18.3143 9.2358 18.6063 9.4467 18.7112 9.7626L19.5403 12.2499H21.9998C22.4139 12.2499 22.75 12.5858 22.75 12.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlIcon);
export default __webpack_public_path__ + "static/media/control-icon.08a9c717d31cc4e890c934140d498b05.svg";
export { ForwardRef as ReactComponent };